import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import settle from './modules/settle'
import schedule from './modules/schedule'
import trans from './modules/trans'
import user from './modules/user'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

// ────────────────────────────────────────────────────────
// 스피너 suppress depth — Vuex state 밖 모듈 스코프에 보관.
// 이유:
//   1) axios 인터셉터가 동기적으로 read 만 하면 되고 reactive 가 필요 없음
//   2) Vuex strict 모드 — mutation 외부에서의 state 변경 금지 →
//      action 내부 ++/-- 가 state 가 아니라 일반 변수면 strict 위반 X
// ────────────────────────────────────────────────────────
let suppressDepth = 0

export function isSpinnerSuppressed () {
  return suppressDepth > 0
}

const store = new Vuex.Store({
  state: {
    LoadingStatus: false,
    LoadingCnt: 0,
    workingEiCatCd: '',
    personalizedFlag: false,
    isOpenPersonalized: false
  },
  mutations: {
    startSpinner (state) {
      state.LoadingStatus = true
      state.LoadingCnt++
    },
    endSpinner (state) {
      state.LoadingCnt--
      if (state.LoadingCnt <= 0) {
        state.LoadingCnt = 0
        state.LoadingStatus = false
      }
    },
    updateWorkingEiCatCd (state, payload) {
      state.workingEiCatCd = payload
    },
    updatePersonalizedFlag (state) {
      state.personalizedFlag = !state.personalizedFlag
    },
    updateIsOpenPersonalized (state, payload) {
      state.isOpenPersonalized = payload
    }
  },
  actions: {
    /**
     * 여러 API 호출을 하나의 스피너 사이클로 묶음.
     * 블록 안의 axios 호출은 spinner 옵션과 무관하게 카운터를 안 건드림.
     *
     * 사용 예:
     *   await this.$store.dispatch('withSpinner', async () => {
     *     await api1(...)
     *     await api2(...)
     *   })
     * 또는 thin wrapper:
     *   await this.$withSpinner(async () => { ... })   // plugins/spinner.js
     */
    async withSpinner ({ commit }, fn) {
      commit('startSpinner')
      suppressDepth++
      try {
        return await fn()
      } finally {
        suppressDepth--
        commit('endSpinner')
      }
    }
  },
  modules: {
    auth,
    settle: settle,
    schedule: schedule,
    trans: trans,
    user: user
  },
  plugins: [
    createPersistedState({ storage: sessionStorage, paths: ['auth'] })
  ],
  // 빌드 mode 가 prd/stg/dev 여도 vue-cli 가 NODE_ENV 를 development 로 설정하므로
  // NODE_ENV 로 판단하면 운영에서도 strict 가 켜진다. (mutation 마다 state 전체 deep watch)
  strict: process.env.VUE_APP_MODE === 'LOCAL'
})

export default store
